export default {
  name: "v-breadcrumbs",
  props: {
    breadcrumbs: {
      require: true,
      type: Array
    }
  }
};